import { User } from 'oidc-client';

interface AuthState {
  accessToken?: string;
  isAuthenticated: boolean;
  isLoading: boolean;
  error?: Error;
  user?: User;
  isSignIn?: boolean;
}

export const defaultAuthState: AuthState = {
  isAuthenticated: false,
  isLoading: true,
  isSignIn: false
};

export default AuthState;
